import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["srcset", "media"]
const _hoisted_3 = ["srcset", "media"]
const _hoisted_4 = ["src", "alt", "width", "height", "loading"]
const _hoisted_5 = ["src", "alt", "width", "height", "loading"]

import {
  withDefaults,
  reactive,
  computed,
  onMounted,
  toRefs,
  watch,
} from 'vue'
import { BREAK_POINTS } from '@/constants/mediaQuery'

interface Props {
  lazyLoad?: boolean
  src: string
  srcSp?: string
  alt?: string
  noImageSrc?: string
  width?: number | string
  height?: number | string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppImage',
  props: {
    lazyLoad: { type: Boolean, default: true },
    src: null,
    srcSp: { default: '' },
    alt: { default: '' },
    noImageSrc: { default: require('@/assets/image/img_book_none.svg') },
    width: null,
    height: null
  },
  setup(__props: any) {

const props = __props as { lazyLoad: boolean, src: string, srcSp: string, alt: string, noImageSrc: string, width?: number | string, height?: number | string }

/**
 * AppImage.
 *
 * srcの読み込み, PC/SPでの画像出しわけ, width/heightの自動付与, 遅延ロードなどが可能.
 */

const breakPoints = BREAK_POINTS



const size = reactive({
  width: props.width,
  height: props.height,
})

const loading = computed(() => (props.lazyLoad ? 'lazy' : undefined))

/**
 * init.
 *
 * 画像本来のwidth, heightを取得する.
 * Propsでwidthとheightを受け取っている場合は取得しない.
 */
const init = () => {
  if (props.width && props.height) {
    return
  }

  const src = props.src
  const img = new Image()

  img.onload = () => {
    size.width = props.width ?? img.naturalWidth
    size.height = props.height ?? img.naturalHeight
  }

  img.src = src
}

const { src } = toRefs(props)

watch(src, init)

onMounted(() => {
  init()
})

return (_ctx: any,_cache: any) => {
  const _directive_fallback_image = _resolveDirective("fallback-image")!

  return (__props.srcSp)
    ? (_openBlock(), _createElementBlock("picture", _hoisted_1, [
        _createElementVNode("source", {
          srcset: __props.srcSp,
          media: `(max-width: ${_unref(breakPoints).sp}px)`
        }, null, 8, _hoisted_2),
        _createElementVNode("source", {
          srcset: _unref(src),
          media: `(min-width: ${_unref(breakPoints).pc}px)`
        }, null, 8, _hoisted_3),
        _withDirectives(_createElementVNode("img", {
          src: _unref(src),
          alt: __props.alt,
          width: size.width,
          height: size.height,
          loading: _unref(loading)
        }, null, 8, _hoisted_4), [
          [_directive_fallback_image, __props.noImageSrc]
        ])
      ]))
    : _withDirectives((_openBlock(), _createElementBlock("img", {
        key: 1,
        src: _unref(src),
        alt: __props.alt,
        width: size.width,
        height: size.height,
        loading: _unref(loading)
      }, null, 8, _hoisted_5)), [
        [_directive_fallback_image, __props.noImageSrc]
      ])
}
}

})